import { useEffect, useMemo, useState } from "react";
import Table from "../../components/GTable/Table";
import { GetCategoriesData } from "../../lib/data";
import Button from "../../components/GButton/Button";
import { categoiresColumns, statusOfCategories } from "../../lib/definitions";
import { deleteCategoriesForm } from "../../lib/actions";
import DeleteRecord from "../../ui/Models/deleteRecord";
import Pagination from "../../ui/paginations/Paginations";
import TableSkeleton from "../../ui/sharedUi/tableSkeleton";
import { useSearchParams } from "react-router-dom";
import CategoriesFilter from "../../ui/searchFilter/categoriesFilter";
import i18n from "../../lib/i18n";

export default function Categories() {

    const [searchParams] = useSearchParams();
    const [categoriesData, setCategoriesData] = useState([]);
    const [categoriesDataFilter, setCategoriesDataFilter] = useState([]);
    const [currentPage, setcurrentPage] = useState(1);
    const [last_page, setlast_page] = useState(1);
    const [deleteConfirmation, setDeleteConfirmation] = useState({ isOpen: false, idToDelete: null });
    const [isLoading, setIsLoading] = useState(true);  
    const [loadingDelete, setLoadingDelete] = useState(false);  
    // const user = JSON.parse(localStorage.getItem("userData"));
    // const userType = user.type;
    const category_id = searchParams.get('category_id');
    const name = searchParams.get('name');
    const status = searchParams.get('status');
    const t = i18n.t.bind(i18n); 

    const params = useMemo(() => {
        const tempParams = [];
        if (category_id) tempParams.push({ category_id });
        if (name) tempParams.push({ name });
        if (status) tempParams.push({ status });

        return tempParams;
    }, [ status, category_id, name]);

    useEffect(() => {
        handleApi();
    }, [currentPage, params])

    useEffect(() => {
        handleFilter();
    }, [])

    const handleApi = async () => {
        setIsLoading(true); 
        const categoriesData = await GetCategoriesData(currentPage, params);
        setCategoriesData([]);
        setcurrentPage(categoriesData.pagination.current_page);
        setlast_page(categoriesData.pagination.last_page);
        categoriesData.data.map((e) => setCategoriesData((prev) => [...prev, e]));
        setIsLoading(false);  
    };

    const handleFilter = async () => {
            const categoriesDataFilter = await GetCategoriesData();
            setCategoriesDataFilter([]);
            categoriesDataFilter.data.map((e) => setCategoriesDataFilter((prev) => [...prev, e]));
    };

    const search = async (param) => {
        const params = [ {"name": param} ];
        if(param){
            const categoriesDataFilter = await GetCategoriesData(1,params);
            setCategoriesDataFilter([]);
            categoriesDataFilter.data.map((e) => setCategoriesDataFilter((prev) => [...prev, e]));
        }
    };

    const handlePageChange = (page) => {
        setcurrentPage(page);
    };

    const openDeleteConfirmation = (id) => {
        setDeleteConfirmation({ isOpen: true, idToDelete: id });
    };

    const closeDeleteConfirmation = () => {
        setDeleteConfirmation({ isOpen: false, idToDelete: null });
    };

    const handelDelete = async () => {
        if (deleteConfirmation.idToDelete) {
            setLoadingDelete(true);
            const result = await deleteCategoriesForm(deleteConfirmation.idToDelete);
            if (result) {
                setLoadingDelete(false);
                handleApi();
            }
            closeDeleteConfirmation();
        }
    };

    return (
        <div className="p-8 sm:p-6 md:p-8">
            {/* {userType == "employee" && ( */}
                <div className="">
                    <CategoriesFilter search={search} categoriesData={categoriesDataFilter} statusOfCategories={statusOfCategories} values={params} />
                </div>
            {/* )} */}
            <div className="flex flex-col sm:flex-row sm:items-baseline border-t border-gray-500/100 bg-thirdly  justify-between px-5 py-5  gap-4">
                <div></div>
                <Button background="#2F7A74" borderRadius="8px" color="white" padding="8px 20px" text={t("button.add_categories")}   nav={"/categories/add"}  />
            </div>
            <div>
                {isLoading ? <TableSkeleton cols={categoiresColumns}/> : (  
                    <Table columns={categoiresColumns} rows={categoriesData} openDeleteConfirmation={openDeleteConfirmation} edit="/categories/edit" />
                )}
            </div>
            <div className="flex justify-center items-center py-5">
                <Pagination currentPage={currentPage} totalPages={last_page} handleChangePage={handlePageChange} />
            </div>
            {deleteConfirmation.isOpen && <DeleteRecord loadingDelete={loadingDelete} handelDelete={handelDelete} closeDeleteConfirmation={closeDeleteConfirmation} />}
        </div>
    );
};